export default "__VITE_ASSET__8baMmMDC__"